/* Kiro — Barely There Skin Tint: swatch-group scroll story v4
   Five glossy pools glide out from behind the tube and bloom into one overlapping swatch group,
   scrubbed by scroll across points 01–05. Transform/opacity only, frame-rate independent smoothing. */
(function () {
  var SW = 390, SH = 420, POOL_IMG = 744 / 600, POOL_AR = 750 / 744;
  // h: tube height on the 390×420 stage. 385 (was 350, +10%) keeps the visible tube inside the stage (≈22–406px), so the copy and 01–05 nav stay clear.
  var TUBE = { cx: 198, cy: 214, h: 385, rot: -8 };
  TUBE.w = TUBE.h * 344 / 806;                 // image width incl. shadow margin, natural proportion
  TUBE.H = TUBE.w * 926 / 344;
  // Pools, back → front. x, y: centre on the 390×420 stage; d: pool diameter; z: depth; t: bloom window
  var POOLS = {
    '37W': { x: 292, y: 122, d: 166, z: 0.5, t: [0.40, 0.70] },
    '25W': { x: 116, y: 142, d: 224, z: 0.7, t: [-0.12, 0.24] },
    '45W': { x: 104, y: 312, d: 164, z: 0.9, t: [0.24, 0.56] },
    '40N': { x: 212, y: 368, d: 116, z: 1.0, t: [0.54, 0.82] },
    '10C': { x: 290, y: 278, d: 198, z: 0.8, t: [0.08, 0.40] }
  };

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function range(v, a, b) { return clamp((v - a) / (b - a), 0, 1); }
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
  function easeOutQuint(t) { return 1 - Math.pow(1 - t, 5); }
  function easeInOut(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function initKst(root) {
    if (!root || root.__kst) return;
    root.__kst = true;
    var doc = root.ownerDocument, win = doc.defaultView;
    var STEPS = 5;
    var pin = root.querySelector('.kst__pin');
    var art = root.querySelector('.kst__art');
    var stage = root.querySelector('.kst__stage');
    var tube = root.querySelector('.kst__tube');
    var items = root.querySelectorAll('.kst__item');
    var buttons = root.querySelectorAll('.kst__nav button');
    var reduce = win.matchMedia('(prefers-reduced-motion: reduce)');

    tube.style.setProperty('width', TUBE.w + 'px', 'important');
    tube.style.setProperty('height', TUBE.H + 'px', 'important');
    var pools = [];
    root.querySelectorAll('.kst__pool').forEach(function (img) {
      var cfg = POOLS[img.getAttribute('data-code')];
      if (!cfg) return;
      var w = cfg.d * POOL_IMG;
      img.style.setProperty('width', w + 'px', 'important');
      img.style.setProperty('height', (w * POOL_AR) + 'px', 'important');
      pools.push({ el: img, c: cfg, w: w, h: w * POOL_AR });
    });

    var phone = win.matchMedia('(max-width: 700px)');
    var copyEl = root.querySelector('.kst__copy'), navEl = root.querySelector('.kst__nav');
    function layout() {
      var w = art.clientWidth, h = art.clientHeight;
      if (phone.matches) {
        // size the art box to the swatch group itself so there is no dead space above the copy
        var cs = win.getComputedStyle(pin);
        var avail = pin.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom) - copyEl.offsetHeight - navEl.offsetHeight - 30;
        var kp = Math.max(0.1, Math.min(w * 1.06 / SW, avail / SH));
        root.style.setProperty('--kst-art-h', Math.round(SH * kp) + 'px');
        h = SH * kp;
      } else root.style.removeProperty('--kst-art-h');
      var k = Math.max(0.1, Math.min(w * 1.06 / SW, h / SH));
      stage.style.setProperty('--kst-k', k.toFixed(4));
      // keep the pin below a sticky/fixed site header and above a sticky add-to-bag bar
      var hd = doc.querySelector('header'), e = hd, top = 0, bottom = 0;
      while (e && e !== doc.body) {
        var pos = win.getComputedStyle(e).position;
        if (pos === 'sticky' || pos === 'fixed') { top = Math.round(hd.getBoundingClientRect().height); break; }
        e = e.parentElement;
      }
      Array.prototype.forEach.call(doc.querySelectorAll('body *'), function (el) {
        if (root.contains(el)) return;
        var cs = win.getComputedStyle(el);
        if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
        var r = el.getBoundingClientRect();
        if (r.height > 20 && r.height < 200 && r.width > win.innerWidth * 0.8 && Math.abs(r.bottom - win.innerHeight) < 2) bottom = Math.max(bottom, Math.round(r.height));
      });
      root.style.setProperty('--kst-top', top + 'px');
      root.style.setProperty('--kst-bottom', bottom + 'px');
    }
    function relayout() { layout(); layout(); }   // second pass uses the settled top/bottom offsets

    var target = 0, current = 0, lead = 0, leadCur = 0, active = -1, raf = 0, last = 0;

    function measure() {
      var r = root.getBoundingClientRect();
      var travel = Math.max(1, root.offsetHeight - pin.offsetHeight);
      target = r.top > 0 ? 0 : clamp((pin.getBoundingClientRect().top - r.top) / travel, 0, 1);
      lead = clamp((win.innerHeight - r.top) / win.innerHeight, 0, 1);
    }

    function render(now) {
      var dt = last ? Math.min(64, now - last) : 16; last = now;
      var a = 1 - Math.pow(1 - 0.11, dt / 16.67);
      current += (target - current) * a;
      leadCur += (lead - leadCur) * a;
      if (Math.abs(target - current) < 0.0002) current = target;
      if (Math.abs(lead - leadCur) < 0.0002) leadCur = lead;
      var p = current;
      var entry = easeOutCubic(range(leadCur, 0.15, 1));
      var finale = easeInOut(range(p, 0.78, 1));
      var drift = easeInOut(p);

      // tube: rises into place, then breathes slightly upright over the finale
      var tY = 40 * (1 - entry) - 8 * drift;
      var tR = TUBE.rot + 3 * finale;
      var tS = (0.94 + 0.06 * entry) * (1 + 0.02 * finale);
      tube.style.opacity = entry.toFixed(3);
      tube.style.transform = 'translate3d(' + (TUBE.cx - TUBE.w / 2).toFixed(2) + 'px,' + (TUBE.cy - TUBE.H / 2 + tY).toFixed(2) + 'px,0) rotate(' + tR.toFixed(2) + 'deg) scale(' + tS.toFixed(4) + ')';

      // pools: glide out from behind the tube and bloom into place, overlapping in time
      for (var i = 0; i < pools.length; i++) {
        var P = pools[i], c = P.c;
        var t = c.t[0] < 0
          ? clamp(0.3 * range(leadCur, 0.55, 1) + 0.7 * range(p, 0, c.t[1]), 0, 1)
          : range(p, c.t[0], c.t[1]);
        var m = easeOutQuint(t), g = easeOutCubic(t);
        var fromX = TUBE.cx + (c.x - TUBE.cx) * 0.22, fromY = TUBE.cy + (c.y - TUBE.cy) * 0.22;
        var x = fromX + (c.x - fromX) * m;
        var y = fromY + (c.y - fromY) * m - 14 * c.z * drift;
        var s = (0.32 + 0.68 * g) * (1 + 0.025 * finale);
        P.el.style.opacity = range(t, 0, 0.22).toFixed(3);
        P.el.style.transform = 'translate3d(' + (x - P.w / 2).toFixed(2) + 'px,' + (y - P.h / 2).toFixed(2) + 'px,0) scale(' + s.toFixed(4) + ')';
      }

      // copy + nav
      var pos = p * STEPS;
      var idx = clamp(Math.floor(pos), 0, STEPS - 1);
      if (idx !== active) {
        for (var j = 0; j < items.length; j++) {
          items[j].classList.toggle('is-active', j === idx);
          items[j].classList.toggle('is-past', j < idx);
          items[j].setAttribute('aria-hidden', j === idx ? 'false' : 'true');
          if (buttons[j]) { buttons[j].classList.toggle('is-active', j === idx); buttons[j].setAttribute('aria-current', j === idx ? 'step' : 'false'); }
        }
        active = idx;
      }
      for (var b = 0; b < buttons.length; b++) buttons[b].style.setProperty('--fill', clamp(pos - b, 0, 1).toFixed(3));

      if (current !== target || leadCur !== lead) raf = win.requestAnimationFrame(render);
      else { raf = 0; last = 0; }
    }

    function tick() {
      if (reduce.matches) { target = current = lead = leadCur = 1; }
      else measure();
      if (!raf) raf = win.requestAnimationFrame(render);
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        var travel = root.offsetHeight - pin.offsetHeight;
        var top = root.getBoundingClientRect().top + win.scrollY - (parseFloat(win.getComputedStyle(root).getPropertyValue('--kst-top')) || 0);
        win.scrollTo({ top: top + travel * ((i + 0.5) / STEPS), behavior: reduce.matches ? 'auto' : 'smooth' });
      });
    });

    relayout();
    win.addEventListener('scroll', tick, { passive: true });
    win.addEventListener('resize', function () { relayout(); tick(); });
    if ('ResizeObserver' in win) new win.ResizeObserver(function () { layout(); tick(); }).observe(pin);
    win.addEventListener('load', function () { relayout(); tick(); });
    tick();
  }

  window.KiroSkinTintStory = initKst;
  function boot() { document.querySelectorAll('[data-kst]').forEach(initKst); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Shopify theme editor: re-run when the section is added or re-rendered
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-kst]').forEach(initKst); });
})();
